<ng-container *transloco="let t; prefix: 'ler-header'">
  <header>
    <img src="assets/images/accredible-new-logo.svg" alt="" />

    @if (user()) {
      <div class="user-menu">
        <button class="btn-profile" data-cy="btn-header-profile" [cdkMenuTriggerFor]="menu">
          <accredible-avatar
            [isLoading]="false"
            [imageUrl]="user().avatar"
            [name]="user().name"
            [size]="'26px'"
            [withBorder]="false">
          </accredible-avatar>

          <span class="font-normal-regular">{{ user().name }}</span>
        </button>
      </div>
    } @else {
      <a class="btn-sign-in" data-cy="link-header-sign-in" [href]="accountsLoginUrl">
        <accredible-avatar [isLoading]="false" [size]="'26px'" />

        <span class="font-normal-regular">{{ t('sign_in') }}</span>
      </a>
    }
  </header>

  <ng-template #menu>
    <div cdkMenu class="ler-header-menu">
      <a cdkMenuItem data-cy="link-header-menu-dashboard" routerLink="dashboard">
        <accredible-icon icon="grid" size="20px" />
        {{ t('dashboard') }}
      </a>

      <a cdkMenuItem data-cy="link-header-menu-journey" routerLink="journey">
        <accredible-icon icon="ec-degree" size="20px" />
        {{ t('journey') }}
      </a>

      <a cdkMenuItem data-cy="link-header-menu-jobs" routerLink="jobs">
        <accredible-icon icon="suitcase" size="20px" />
        {{ t('jobs') }}
      </a>

      <button
        cdkMenuItem
        class="btn-sign-out"
        data-cy="btn-header-menu-sign-out"
        (click)="logout()">
        {{ t('sign_out') }}
      </button>
    </div>
  </ng-template>
</ng-container>
